module.exports = __webpack_public_path__ + "edd31e2f72e0e1fb21f1d73e9a3bf853.png";